import ResetPassword from 'pages/updatePassword/ResetPassword';

const ResetRoute = {
  path: '/reset-password/:id',
  element: <ResetPassword />
};

export default ResetRoute;
